import dropUndefined from '../utils/dropUndefined';
const dataTypeToWuji = {
    array: 0,
    null: 0,
    object: 0,
    any: 0,
    string: 1,
    integer: 8,
    boolean: 9,
    // datetime: 10,
    number: 21,
};
const fieldTypes = {
    100: { /* 自增ID */ type: 'number', value: '' },
    101: { /* 自定义ID */ type: 'string', value: '' },
    102: { /* 系统内默认ID */ type: 'string', value: '' },
    103: { /* 整型自定义ID */ type: 'number', value: '' },
    104: { /* 随机ID */ type: 'string', value: '' },
    1: { /* 文本输入框（单行） */ type: 'string', value: '' },
    2: { /* 多行文本输入框  */ type: 'string', value: '' },
    3: { /* Url链接 */ type: 'string', value: '' },
    4: { /* 图片（url） */ type: 'string', value: '' },
    5: { /* 下拉选择框 */ type: 'string', value: '' },
    6: { /* 智能选择框 */ type: 'string', value: '' },
    7: { /* 关联对象 */ type: 'string', value: '' },
    8: { /* 数字输入 */ type: 'integer', value: 0 },
    9: { /* CheckBox */ type: 'boolean', value: false },
    10: { /* 日期 */ type: 'number', value: 0 },
    11: { /* 创建时间 */ type: 'number', value: 0 },
    12: { /* 修改时间 */ type: 'number', value: 0 },
    13: { /* 下拉选择框（多选） */ type: 'string', value: '' },
    14: { /* 创建用户 */ type: 'string', value: '' },
    15: { /* 颜色 */ type: 'string', value: '' },
    16: { /* 富文本 */ type: 'string', value: '' },
    17: { /* 新版富文本 */ type: 'string', value: '' },
    18: { /* 自动排序 */ type: 'number', value: '' },
    19: { /* 大文本 */ type: 'string', value: '' },
    20: { /* JSON字符串 */ type: 'string', value: '' },
    21: { /* 数字输入 -  浮点数 */ type: 'number', value: '' },
    22: { /* 文件上传 */ type: 'string', value: '' },
    23: { /* 配置管理人（rtx，可多选） */ type: 'string', value: '' },
    24: { /* 修改 */ type: 'string', value: '' },
    25: { /* 代码块 */ type: 'string', value: '' },
    26: { /* 真-JSON */ type: 'any', value: null },
    27: { /* RTX  */ type: 'string', value: '' },
    28: { /* 密文  */ type: 'string', value: '' },
    29: { /* exeditor富文本  */ type: 'string', value: '' },
};
const UI_TYPE_WUJI_OMNI_INPUT = 'wujiOmniInput';
const fallbackFieldType = { type: 'any', value: null };
export function fromWujiFieldInfo(field) {
    var _a, _b;
    const fieldType = fieldTypes[field.type] || fallbackFieldType;
    // if (!fieldType) throw new Error(`Unknown FieldType ${field.type}`);
    const ans = {
        id: field.id,
        type: fieldType.type,
        title: field.name,
        description: field.desc,
        readonly: !!field.readonly,
        default: (_a = field.value) !== null && _a !== void 0 ? _a : fieldType.value,
        // required: !!field.required,
        validation: dropUndefined({
            pattern: field.pattern || undefined,
            maxLength: +(field.maxlength || 0) || undefined,
        }),
        ui: {
            type: UI_TYPE_WUJI_OMNI_INPUT,
            settings: Object.assign({}, field),
            triggers: field.triggers || undefined,
            width: field.width || undefined,
            trim: !field.notAutoSpace || undefined,
        },
    };
    switch (+field.type) {
        case 5: // 下拉选择框（单选）
        case 13: // 下拉选择（多选）
            ans.enum = (_b = computeOptions(field.args)) === null || _b === void 0 ? void 0 : _b.map((x) => ({ label: x.label, value: x.value }));
            break;
    }
    if (field.type >= 100)
        ans.isPrimaryKey = true;
    if (!Object.keys(ans.validation).length)
        delete ans.validation;
    return dropUndefined(ans, true);
}
export function toWujiFieldInfo(schema) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const type = dataTypeToWuji[(_a = schema.type) !== null && _a !== void 0 ? _a : 'any'];
    if (!type)
        throw new Error(`Wuji doesn't support '${schema.type}' field`);
    if (!schema.id)
        throw new Error(`Field id is required in Wuji`);
    const ans = {
        id: schema.id,
        type,
        name: schema.title || schema.id,
        desc: schema.description,
        value: schema.default,
        readonly: schema.readonly,
        required: schema.required,
        triggers: (_b = schema.ui) === null || _b === void 0 ? void 0 : _b.triggers,
        width: (_c = schema.ui) === null || _c === void 0 ? void 0 : _c.width,
        notAutoSpace: (_d = schema.ui) === null || _d === void 0 ? void 0 : _d.trim,
        maxlength: (_e = schema.validation) === null || _e === void 0 ? void 0 : _e.maxLength,
        pattern: (_f = schema.validation) === null || _f === void 0 ? void 0 : _f.pattern,
    };
    if (((_g = schema.ui) === null || _g === void 0 ? void 0 : _g.type) === UI_TYPE_WUJI_OMNI_INPUT) {
        Object.assign(ans, schema.ui.settings);
    }
    else {
        if (schema.isPrimaryKey) {
            // 自定义 ID
            if (schema.type === 'string')
                ans.type = 101;
            // 自增ID
            else
                ans.type = 100;
        }
        // 字符串下拉框，把枚举转换过去
        if (type === 1 && ((_h = schema.enum) === null || _h === void 0 ? void 0 : _h.length)) {
            ans.type = 5;
            ans.args = `LIST:${JSON.stringify({
                options: schema.enum.map((x) => ({ label: x.label || x.value, value: x.value })),
            })}`;
        }
    }
    return dropUndefined(ans);
}
/**
 * 解析无极下拉框配置，见无极的 client src/client/modules/field-args/select.js
 */
function computeOptions(args) {
    try {
        const c = args.replace(/^(LIST|RELATE):/, '');
        if (c[0] === '{')
            return JSON.parse(c).options;
        return c.split(',').map((opt) => {
            const kv = opt.split('|');
            return {
                value: kv[0],
                label: kv[1],
                groups: [],
            };
        });
    }
    catch (e) { }
}
